<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          fab
          dark
          v-bind="attrs"
          v-on="on"
          :loading="isCreating"
        >
          <v-icon color="black">add</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Create title and description
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="form.level_benefit_name_th"
              label="TITLE (TH)"
              required
            ></v-text-field>

            <v-text-field
              v-model="form.level_benefit_name_en"
              label="TITLE (EN)"
              required
            ></v-text-field>

            <v-text-field
              v-model="form.level_benefit_description_th"
              label="DESCRIPTION (TH)"
              required
            ></v-text-field>

            <v-text-field
              v-model="form.level_benefit_description_en"
              label="DESCRIPTION (EN)"
              required
            ></v-text-field>
            <v-layout row align-center>
              <span style="font-size:16px;">Level Benefit image:</span>
              <v-btn
                color="info"
                class="white--text"
                @click="$refs.LogoInput.click()"
              >
                Upload
              </v-btn>
              <input
                style="display:none;"
                type="file"
                @change="onImageSelected"
                ref="LogoInput"
                accept="image/*"
              />
            </v-layout>
            <img
              :src="form.level_benefit_image"
              v-if="form.level_benefit_image"
              width="100px"
              height="100px"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" text @click="cancleCreate()">
            cancle
          </v-btn>
          <v-btn color="primary" text @click="createLevelBenefit()">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    item: Array,
    level_id: Number,
  },
  data() {
    return {
      dialog: false,
      isCreating: false,
      valid: true,
      form: {
        level_benefit_name_th: "",
        level_benefit_name_en: "",
        level_benefit_description_th: "",
        level_benefit_description_en: "",
        level_benefit_image: "",
        level_benefit_level_id: null,
        level_benefit_status: 1,
        level_benefit_series: 999,
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        level_benefit_name_th: "",
        level_benefit_name_en: "",
        level_benefit_description_th: "",
        level_benefit_description_en: "",
        level_benefit_image: "",
        level_benefit_level_id: null,
        level_benefit_status: 1,
        level_benefit_series: 999,
      };
    },
    async createLevelBenefit() {
      if (this.$refs.form.validate()) {
        let formCopy = JSON.parse(JSON.stringify(this.form));
        formCopy.level_benefit_level_id = this.level_id;
        let result = await this.$store.dispatch(
          "tierBenefits/createLevelBenefit",
          formCopy
        );

        this.isCreating = true;

        if (result == true) {
          this.resetForm();
          this.dialog = false;
        }
        this.isCreating = false;
      }
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.form.level_benefit_image = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    cancleCreate() {
      this.dialog = false;
      this.resetForm();
    },
  },
};
</script>
<style scoped>
.button {
  display: flex;
  align-content: center;
}
</style>
